import { useMemo } from 'react'

import {
  AvcAudioInputConfigTypeEnum,
  AvcOutputConfigTypeEnum,
  AvcSourceConfigTypeEnum,
  AvcVideoInputConfigTypeEnum,
} from '@nativewaves/nw-cloud-sdk/content'
import { upperFirst } from 'lodash-es'
import { useFormContext } from 'react-hook-form'

import { FormStructure } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask/Task/Config'

type AvcConfigEntities = {
  sources: AvcSourceConfigTypeEnum
  videoInputs: AvcVideoInputConfigTypeEnum
  audioInputs: AvcAudioInputConfigTypeEnum
  outputs: AvcOutputConfigTypeEnum
}

export const useMeaningfulDefaultName = <E extends keyof AvcConfigEntities>(entity: E) => {
  const { getValues } = useFormContext<FormStructure>()

  return useMemo(
    () => `${upperFirst(entity).slice(0, -1)} ${(getValues().config?.data[entity]?.length || 0) + 1}`,
    [entity, getValues],
  )
}
